import { MedplumClient } from "@medplum/core";

import { joinReferenceString } from "@/utils/medplum";

export const getActiveLaborAndDeliveryEncounter = async (
  medplum: MedplumClient,
  clientId?: string,
) => {
  if (!clientId) return;

  const laborAndDeliveryEncounter = await medplum.searchOne("Encounter", {
    subject: joinReferenceString("Patient", clientId),
    type: "57083-8",
    status: "in-progress",
    _sort: "-_lastUpdated",
  });

  return laborAndDeliveryEncounter;
};
